/* eslint-disable jsx-a11y/anchor-is-valid */

import { Link, Text, View } from '@react-pdf/renderer';
import { CorrespondentContact as ICorrespondentContact } from '../../../models/pro.model';
import styles from '../pro-report-pdf-styles';

interface CorrespondentContactProps {
  correspondentContact?: ICorrespondentContact | null;
}

function CorrespondentContact({
  correspondentContact,
}: CorrespondentContactProps) {
  return (
    <View wrap={false} style={styles.table}>
      <View style={styles.tableRow}>
        <Text style={styles.tableHeaderFullWidth}>Correspondent contact</Text>
      </View>
      {correspondentContact && (
        <>
          <View style={styles.tableRow}>
            <Text style={styles.tableSubHeaderFullWidth}>
              <Text style={{ fontWeight: 700 }}>Company:</Text>{' '}
              {correspondentContact.company ?? 'N/A'}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text
              style={{
                ...styles.tableCellReducedWidth,
                borderRightWidth: 0,
                width: '50%',
              }}
            >
              <Text style={{ fontWeight: 700 }}>Name:</Text>{' '}
              {correspondentContact.name ?? 'N/A'}
            </Text>
            <Text style={styles.tableCellFullWidth}>
              <Text style={{ fontWeight: 700 }}>Email:</Text>{' '}
              {correspondentContact.email ? (
                <Link
                  src={`mailto:${correspondentContact.email}`}
                  style={styles.mailToLink}
                >
                  {correspondentContact.email}
                </Link>
              ) : (
                'N/A'
              )}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCellFullWidth}>
              <Text style={{ fontWeight: 700 }}>Telephone:</Text>{' '}
              {correspondentContact.telephone ?? 'N/A'}
            </Text>
          </View>
        </>
      )}
      <View style={styles.tableRow}>
        <Text style={styles.tableCellFullWidth}>
          Visit our{' '}
          <Link
            src="https://north-standard.com/correspondents-search"
            style={styles.link}
          >
            Correspondents Search
          </Link>{' '}
          for our global network of correspondents.
        </Text>
      </View>
    </View>
  );
}

CorrespondentContact.defaultProps = {
  correspondentContact: null,
};
export default CorrespondentContact;
